import type {FC} from 'react';

import {OverlayScrollbarsComponent} from 'overlayscrollbars-react';

import type {Props} from './types';

import * as S from './styles';

export const ModalBody: FC<Props> = ({
  children,
  modalPadding,
  scrollContainerId,
}) => {
  return (
    <OverlayScrollbarsComponent
      defer
      options={{
        scrollbars: {
          autoHide: 'scroll',
        },
      }}
    >
      <S.Container modalPadding={modalPadding}>
        <S.Scroll id={scrollContainerId}>{children}</S.Scroll>
      </S.Container>
    </OverlayScrollbarsComponent>
  );
};
